/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import VivekService from "../Services/Vivekvani";
import DefaultBook from "../Images/defaultBook.png";
import ListPagination from "../Components/ListPagination";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../Styles/Books.css";
import i18n, { _get_i18Lang } from "../i18n";
import { useTranslation } from "react-i18next";
import { useUser } from "../Contexts/UserContext";
import Reset from "../Images/reset.png";
import $ from "jquery";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Breadcrumbs } from "./E-BooksComponent";
import Loader from "./Loader";

const VivekvaniPage = () => {
  const { isSelected, setItemColored } = useUser();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [vivek, setVivek] = useState<any[] | undefined>(undefined);
  const [refresh, setRefresh] = useState(false);
  const [SortValue, setSortValue] = useState("2");
  const [language, setLanguage] = useState<any>("");
  const [LanguageId, setLanguageId] = useState<any>("");
  const [AuthorId, setAuthorId] = useState<any>("");
  const [CategoryId, setCategoryId] = useState<any>("");
  const [writer, setWriter] = React.useState<any>("");
  const [loading, setLoading] = useState(true);

  const [pagination, setPagination] = useState({
    pageNo: 1,
    recordsPerPage: 12,
    totalRecords: 0,
  });

  function ResetData() {
    setSortValue("2");
    setLanguageId("");
    setAuthorId("");
    setCategoryId("");
    setPagination({
      ...pagination,
      pageNo: 0,
    });
  }

  const location = useLocation();
  const navLanguage =
    ((location.state as { magazineLangauge?: string; authorId?: string; authorName?: string } | null)?.magazineLangauge ?? "").trim();
  const state = location.state as { authorId: string; authorName: string };
  const lastResolvedNav = useRef<string | null>(null);

  function ClickOnFilter(lan: string, cat: string, aut: string) {
    setRefresh(false);
    VivekService.getVanis(
      pagination.pageNo === 1
        ? 0
        : pagination.recordsPerPage * pagination.pageNo - 12,
      pagination.recordsPerPage,
      CategoryId,
      false,
      SortValue, //sort
      AuthorId || state?.authorId,
      "",
      LanguageId,
      window.location.pathname === "/magazines/vivekvani/special" ? true : false
    ).then((res) => {
      if (res.status) {
        setVivek(res.result?.items);
        setPagination({
          ...pagination,
          pageNo: 1,
          recordsPerPage: 12,
          totalRecords: res.result?.totalRecords,
        });
      }
    });
  }

  useEffect(() => {
    ClickOnFilter(CategoryId, AuthorId, LanguageId);
    $(".Authorlist > ul > li > div").removeClass("listActive");
    $("#aut-" + AuthorId).addClass("listActive");
    $(".CategoryList > ul > li > div").removeClass("listActive");
    $("#cat-" + CategoryId).addClass("listActive");
    $(".LanguageList > ul > li > div").removeClass("listActive");
    try {
      const escapedId = String(LanguageId).replace(/([!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
      $("#lan-" + escapedId).addClass("listActive");
    } catch (e) {}
  }, [CategoryId, AuthorId, LanguageId]);

  useEffect(() => {
    setItemColored(true);
    ResetData();
  }, [isSelected, setItemColored]);

  useEffect(() => {
    lastResolvedNav.current = null;
  }, [navLanguage]);

  useEffect(() => {
    VivekService.getFilters("vivekvani").then((res) => {
      if (res) {
        setLanguage(res?.result?.languages);
      }
    });
  }, [i18n.language]);

  useEffect(() => {
    if (!navLanguage || !language || language.length === 0) return;
    if (lastResolvedNav.current === navLanguage) return;

    const exact = language.find(
      (lang: any) => String(lang.id).toLowerCase() === navLanguage.toLowerCase()
    );
    const byName = language.find(
      (lang: any) => String(lang.name).toLowerCase() === navLanguage.toLowerCase()
    );
    const matched = exact || byName;
    lastResolvedNav.current = navLanguage;
    if (matched) {
      setLanguageId(matched.id);
    }
  }, [navLanguage, language]);

  useEffect(() => {
    setRefresh(false);
    const fetchData = async () => {
      try {
        const response = await VivekService.getVanis(
          pagination.pageNo === 1
            ? 0
            : pagination.recordsPerPage * pagination.pageNo - 12,
          pagination.recordsPerPage,
          CategoryId,
          false,
          SortValue,
          AuthorId || state?.authorId,
          "",
          LanguageId,
          window.location.pathname === "/magazines/vivekvani/special" ? true : false
        )
        const res = await response;
        setVivek(res.result?.items);
        setWriter(res?.result?.items[0]?.author);
        setPagination({
          ...pagination,
          recordsPerPage: 12,
          totalRecords: res.result?.totalRecords,
        });
        // .then((res) => {
        //   if (res.status) {
        //     setVivek(res.result?.items);
        //     setWriter(res?.result?.items[0]?.author);
        //     setPagination({
        //       ...pagination,
        //       recordsPerPage: 12,
        //       totalRecords: res.result?.totalRecords,
        //     });
        //   }
        // });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [refresh, i18n.language, SortValue]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


      const style:any=()=>{
        return(
          <>
            <h1 style={{fontWeight:700,fontSize:"36px"}}>{writer
          ? writer
          : window.location.pathname === "/magazines/vivekvani/special"
          ? t("Special_vivek_vani_tr")
          : t("vivek_vani_tr")}
         </h1>
      
          </>
        )
    }
    
  return (
    <>

<div style={{ backgroundColor: "rgb(255, 237, 188)", padding: "0px 0px 0px 0px",marginTop:"-60px" }}>
      <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "0 10px",backgroundColor:"rgb(255, 237, 188)" }}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: "20px",
                flexWrap: "wrap",
                padding: "28px 0 16px",
              }}
            >
              <div style={{ flex: "0 1 260px", minWidth: "220px" }}>
                <div style={{ padding: "8px 0" }}>
                  <h1 style={{ color: "#cf2c24", fontSize: "40px", margin: 0, fontWeight: 700,marginTop:"70px", textShadow: "0px 0px 4px rgba(255,255,255,0.9)" }}>
                    {t("vivek_vani_tr")}
                  </h1>
                  <div style={{ marginTop: "10px", fontSize: 19,fontWeight:600,color:"rgb(45, 42, 41)" }}>
                    <Link to="/" style={{ marginRight: "8px", color: "#2d2a29" }}>{t("Home_tr")}</Link>
                    <span style={{ margin: "0 6px" }}>/</span>
                    <Link to="/magazines" style={{ marginRight: "8px", color: "#2d2a29" }}>{t("magazine_tr")}</Link>
                    <span style={{ margin: "0 6px" }}>/</span>
                    <span>{t("vivek_vani_tr")}</span>
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "1px",
                  minHeight: "100px",
                  background: "#facc6f",
                  marginTop: "65px",
                }}
              />

              <div style={{ flex: "1 1 520px", minWidth: "300px" }}>
                <h2
                  style={{
                    textAlign: "center",
                    color: "rgb(228, 121, 7)",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.9)",
                    fontWeight: 600,
                    margin: 0,
                    paddingTop:"30px",
                    // marginb:"-10px",
                  }}
                >
                  {t("Vivek_Vani_title_tr")}
                </h2>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "8px",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                  <svg
                    width="26"
                    height="18"
                    viewBox="0 0 26 18"
                    style={{ margin: "0 12px" }}
                  >
                    <rect x="1" y="7" width="2" height="4" rx="1" fill="#E5B15A" />
                    <rect x="5" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="9" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="13" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="17" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="21" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                  </svg>
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                </div>

                <p
                  style={{
                    fontSize: 17,
                    color: "#4a4036",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.8)",
                    // margin: "25px 0 -10px",
                    margin:"18px 0px 0px 0px",
                    width: "100%",
                    lineHeight: 1.75,
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    textAlign: "justify",
                  }}
                >
                  {t("Vivek_Vani_description_tr")}
                </p>
              </div>
            </div>
      </div>
  </div>


      {/* <Breadcrumbs
        mainsubBreadCrumb={style()}
        subBreadCrumb={t("Home_tr")


        }
        navigatemainsubBreadCrumb={() => {
          navigate(`/`);
        }}
        subBreadCrumbTwo={t("magazine_tr")}
        navigatesubBreadCrumb={() => {
          navigate(`/magazines`);
        }}
        subBreadCrumbThree={t("vivek_vani_tr")}
       
      >

        
        </Breadcrumbs> */}

      <div
        className="fontfamily"
        style={{
          userSelect: "none",
          backgroundColor: "rgb(255, 246, 225)",
          padding: "1px 0 3% 0",
        }}
      >
        <div className="containers">
          <div
            className="gst-page-content pagecontentbackground"
            style={{ backgroundColor: "#FFF6E1" }}
          >
            <div className="row">
              <div className="col-lg-3">
                <div
                  style={{
                    display: "block",
                    padding: "16px",
                    borderRadius: "4px",
                    background: "#FFFAF0",
                    boxShadow: "0 0 7px 1px #f5deb1",
                    fontFamily: "ChanakyaUni",
                    height: "100%",
                  }}
                >
                  <div
                    className="cardbackground"
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span className="boxheadtitle">{t("Filter_tr")}</span>
                    {(LanguageId !== "" || pagination.pageNo > 1) && (
                      <img
                        alt="reset"
                        src={Reset}
                        className="resetimg"
                        onClick={() => {
                          ResetData();
                        }}
                      />
                    )}
                  </div>
                  <div>
                    <Accordion elevation={0} defaultExpanded>
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        style={{
                          height: 0,
                          background: "#FFFAF0",
                          minHeight: "25px",
                          marginTop: "15px"
                        }}
                      >
                        <h2 className="filtertitle">{t("Languages_tr")}</h2>
                      </AccordionSummary>

                      <AccordionDetails
                        style={{
                          display: "block",
                          background: "#FFFAF0",
                          // padding: 0,
                        }}
                      >
                        {language &&
                          language.length > 0 &&
                          language?.map((Language: any) => (
                            <div
                              key={`c-${Language.id}`}
                              className="LanguageList"
                              onClick={() => {
                                setLanguageId(Language.id);
                              }}
                            >
                              <ul style={{ margin: 0 }}>
                                <li>
                                  <h2
                                    style={{
                                      fontSize: "21px",
                                      cursor: "pointer",
                                      fontWeight: 400,
                                      color: "#545454",
                                      fontFamily: "ChanakyaUni",
                                    }}
                                    id={`lan-${Language.id}`}
                                  >
                                    {Language.name}
                                  </h2>
                                </li>
                              </ul>
                            </div>
                          ))}
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
              </div>
              <div className="col-lg-9">
                <div
                  className="detailbg"
                  style={{
                    display: "block",
                    padding: "16px",
                    borderRadius: "4px",
                    background: "#FFFAF0",
                    boxShadow: "0 0 7px 1px #f5deb1",
                    height: "100%",
                    fontFamily: "ChanakyaUni",
                  }}
                >
                  <div className="sidebarmargin">
                    <div
                      className="align-items-center row"
                      style={{ margin: "-10px -10px 25px -10px" }}
                    >
                      <div className="col-6">
                        <div className="filter1" style={{ marginTop: "10px" }}>
                          <label>
                            {t("Total_Records_tr")} : {pagination.totalRecords}
                          </label>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="filter1" style={{ textAlign: "right" }}>
                          <label>{t("Sort_tr")} </label>
                          <select
                            style={{ backgroundColor: "#FFF2D5" }}
                            value={SortValue}
                            onChange={(e) => {
                              setSortValue(e.target.value);
                            }}
                          >
                            <option value="3">{t("Popular_tr")}</option>
                            <option value="2">{t("Latest_tr")}</option>
                            <option value="0">{t("General_tr")}</option>
                            <option value="1">{t("Title_tr")}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    {vivek && vivek.length > 0 ? (
                      <div>
                        <div className="row">
                          {vivek.map((viveks) => (
                            <div className="col-lg-3 col-sm-6 col-md-6" key={`aut-${viveks.id}`}>
                              <div
                                className="Authorlist"
                                onClick={() => {
                                   navigate(`/magazines/vivekvani/` + viveks?.slug, {
                                    state: {
                                      vivekvaniId: viveks?.id,
                                      vivekName: viveks.name,
                                      vivekSlug: viveks?.slug
                                    },
                                  });
                                }}
                              >
                                <div className="bookBox">
                                  <a>
                                    <img
                                      style={{
                                        cursor: "pointer",
                                        borderRadius: 0,
                                      }}
                                      src={viveks.vivekVaniThumbPath}
                                      onError={(e) => {
                                        e.currentTarget.src = DefaultBook;
                                      }}
                                      alt={viveks.name}
                                      title={viveks.name}
                                      width="117"
                                      height="165"
                                    />
                                    <h3 style={{ cursor: "pointer",fontSize:'17px',fontWeight:600,margin:'13px 0 0' }}>
                                      {viveks.name}
                                    </h3>
                                  </a>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="col-12" style={{ marginTop: "30px", display: pagination.totalRecords <= 12 ? "none" : "block" }}>
                          <ListPagination
                            totalRecords={pagination.totalRecords}
                            recordsPerPage={pagination.recordsPerPage}
                            currentPage={pagination.pageNo}
                            onClick={(p) => {
                              setPagination({
                                ...pagination,
                                pageNo: p,
                              });
                              setRefresh(true);
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="ebooks-category resultnotfound">
                        {loading && <Loader loading={loading} />}
                        {t("result_not_found_tr")}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default VivekvaniPage;
